import React from 'react';
import './styles.css'
const Footer = ({ children }) => <footer className="footer">{children}</footer>;

export default Footer;